module.exports = __webpack_public_path__ + "static/media/us.ebf772ac.svg";